
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/forget",
      function () {
        return require("private-next-pages/auth/forget/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/forget"])
      });
    }
  